import {
  Button,
  EButtonColorVariant,
  GeneralManageVehiclesOutlineIcon,
  GeneralSunSunIcon,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import { RV_CAMPSITE_BUNDLES_LANDING_PAGE } from '@/constants/urls';

import css from './Tabs.module.css';

export enum ETabsVariant {
  Rentals,
  Delivery,
  RvSite,
}

export enum ETabsColorVariant {
  White,
  Black,
}

interface ITabsProps {
  tabVariant: ETabsVariant;
  colorVariant?: ETabsColorVariant;
}

export const Tabs: React.FC<ITabsProps> = ({
  tabVariant,
  colorVariant = ETabsColorVariant.Black,
}) => {
  const intl = useIntl();

  const tabs = [
    {
      label: intl.formatMessage({ defaultMessage: 'RV Rentals', id: 'ctb+gI' }),
      vairant: ETabsVariant.Rentals,
      Icon: GeneralManageVehiclesOutlineIcon,
      url: '/',
    },
    // {
    //   label: intl.formatMessage({ defaultMessage: 'RV Delivery', id: 'esQwx2' }),
    //   vairant: ETabsVariant.Delivery,
    //   Icon: GeneralMapPinOutlineIcon,
    //   url: '/rv-delivery',
    // },
    {
      label: intl.formatMessage({ defaultMessage: 'Escapes', id: 'HIf3wo' }),
      vairant: ETabsVariant.RvSite,
      Icon: GeneralSunSunIcon,
      url: RV_CAMPSITE_BUNDLES_LANDING_PAGE,
    },
  ];

  return (
    <div className="flex py-1 gap-1 md:gap-3">
      {tabs.map(({ label, url, vairant, Icon }, index) => {
        const isActive = vairant === tabVariant;
        return (
          <Link href={url} key={index} passHref forceClientsideRouting legacy>
            <Button
              label={
                <div className="flex items-center gap-1">
                  <Icon className={css.tabIcon} />
                  <span className="font-normal text-[12px] md:text-[16px]">{label}</span>
                </div>
              }
              variant={isActive ? EButtonColorVariant.Tertiary : EButtonColorVariant.Secondary}
              className={cn('py-2 px-4 border', {
                '!bg-[#212831]': isActive,
                '!bg-[#EEECE3]': colorVariant === ETabsColorVariant.White && !isActive,
              })}
              aria-label={intl.formatMessage(
                { defaultMessage: 'Navigate to {tabName}', id: 'w4XjBW' },
                { tabName: label },
              )}
            />
          </Link>
        );
      })}
    </div>
  );
};
